export default __webpack_public_path__ + "static/media/modal-waves-ripples.5a934d33.png";